import { api } from './api';

export interface AuditEntry {
  id: string;
  company_id: string;
  workspace_id: string | null;
  user_id: string | null;
  action: string;
  target_kind: string | null;
  target_id: string | null;
  payload: Record<string, unknown> | null;
  ip: string | null;
  created_at: string;
}

export const auditLogApi = {
  async list(companyId: string, limit = 100): Promise<AuditEntry[]> {
    const r = await api.get<AuditEntry[]>(`/api/companies/${companyId}/audit-log`, { params: { limit } });
    return r.data;
  },
};
